



























































































import { Component, Watch } from "vue-property-decorator";
import wgetMgr from "../wgetMgr";
import WidgetBase from "../WidgetBase";
import { Message } from "element-ui";
import { getRelProcPrimeDataProps } from "../../../api/index";

const callTransFn = (trans: string, result: any) => {
  const code = trans.replace("function", "window.transFn=function") as string;
  try {
    eval(code);

    const res = (window as any).transFn.call(this, result);
    return res;
  } catch (error) {
    console.error(error);
    Message.error("结果转换函数不合法");
  }
};

@Component({
  name: "ChildrenTableWidget",
  components: {
    selectComponent: () => import("../../../components/SelectComponent/index.vue")
  }
})
export default class ChildrenTableWidget extends WidgetBase {
  private tableData: { [prop: string]: string }[] = [];
  private fn: any = null;
  private showSelectComponent: boolean = false;
  private selectComponentLimiter: string = "";
  private reflectMap: Record<string, string> = {};
  get labelStyle() {
    return {
      color: this.widget.color,
      borderRadius: this.widget.borderRadius + "px",
      backgroundColor: this.widget.backgroundColor,
      textAlign: this.widget.textAlign,
      fontSize: this.widget.fontSize + "px",
      fontWeight: this.widget.fontWeight,
      fontStyle: this.widget.fontStyle,
      height: this.widget.height + "px",
      lineHeight: this.widget.lineHeight + "px",
      paddingLeft: this.widget.paddingLeft + "px",
      paddingRight: this.widget.paddingRight + "px",
      marginTop: this.widget.marginTop + "px",
      marginBottom: this.widget.marginBottom + "px",
      boxSizing: "border-box"
    };
  }

  get headerStyle() {
    return {
      color: this.widget.hColor,
      backgroundColor: this.widget.hBackgroundColor,
      fontSize: this.widget.hFontSize + "px",
      fontWeight: this.widget.hFontWeight,
      fontStyle: this.widget.hFontStyle,
      textAlign: this.widget.hAlign
    };
  }

  get operation() {
    return JSON.parse(this.originData.formRenderData).advance.operation.filter(
      (i: any) => i.source === this.widget.property.propertyName
    );
  }

  get autoCol() {
    return this.operation.some((i: any) => i.direct === "col" && i.target === "auto");
  }

  get autoRow() {
    return this.operation.some((i: any) => i.direct === "row" && i.target === "auto");
  }

  get sTitle() {
    const o = this.operation.find((i: any) => i.target === "auto");
    return o.sTitle;
  }

  cloneWidget(label: string, row: string) {
    return this.widget.widgetList[row].find((i: App.WebForm.Widget) => i.name === label);
  }

  addHandler() {
    const cid: string = Math.random().toString().slice(-4);
    const widget = [
      ...this.widget.widgetList[0].map((i: any) => {
        const o = { ...i };

        o.id = o.id.replace(/:\w*/, `:${cid}`);
        return Object.assign({}, o, {
          value: "",
          text: "",
          ext: {},
          wid: o.wid,
          loop: cid
        });
      })
    ];
    this.widget.widgetList.push(JSON.parse(JSON.stringify(widget)));
  }

  deleteHandler(index: number) {
    this.tableData.splice(index, 1);
    this.widget.widgetList.splice(index, 1);
  }

  @Watch("widget.widgetList", { deep: true, immediate: true })
  widgetListWatcher(n: any[]) {
    this.$nextTick(() => {
      const r: any = [];
      n.forEach((w) => {
        const o: any = {};
        w.forEach((e: App.WebForm.Widget) => {
          const ref = this.$refs[e.id] as any;
          // if (Object.prototype.toString.call(ref) === "[object Array]") {
          //   wgetMgr.setWidgetById(e.id, ref[0]);
          // } else {
          //   }
          wgetMgr.setWidgetById(e.id, ref);
          o[e.property.propertyName] = e.value;
        });
        r.push(o);
      });
      this.tableData = r;
    });
  }

  autoColMethod({ columns, data }: any) {
    const results: any = [];
    const oc = JSON.parse(
      JSON.stringify(
        this.operation.find((i: any) => i.target === "auto" && i.direct === "col").config
      )
    );
    const type: string = oc.input.splice(-1)[0];
    const cols = oc.input;

    columns.forEach((col: any, index: number) => {
      if (index === 0) {
        return (results[index] = this.sTitle);
      }
      if (cols.includes(`[${this.widget.property.propertyName},${col.property}]`)) {
        const values = data.map((item: any) => Number(item[col.property]));
        if (!values.every((value: any) => isNaN(Number(value)))) {
          if (type === "sum" || type === "avr") {
            let sum = values.reduce((prev: any, curr: any) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sum = type === "avr" ? sum / values.length : sum;

            oc.trans && (sum = callTransFn(oc.trans, sum));

            return (results[index] = oc.prefix + sum + oc.suffix);
          } else if (type === "max" || type === "min") {
            let result = Math[type](...values);
            oc.trans && (result = callTransFn(oc.trans, result));
            return (results[index] = oc.prefix + result + oc.suffix);
          }
        } else {
          results[index] = "";
        }
      } else {
        if (type === "custom") {
          const values = data.map((item: any) => Number(item[col.property]));
          if (!values.every((value: any) => isNaN(Number(value)))) {
            eval(oc.input[0]);

            const res = (window as any).fn(col.property, values);

            return (results[index] = res);
          }
        }
        results[index] = "";
      }
    });
    return results;
  }

  autoRowMethod(row: any) {
    if (!Object.keys(row).length) return "";
    try {
      const oc = JSON.parse(
        JSON.stringify(
          this.operation.find((i: any) => i.target === "auto" && i.direct === "row").config
        )
      );
      const reg = new RegExp(`\\[${this.widget.property.propertyName},(.*)\\]`, "gi");
      oc.input.forEach((i: any, index: number, arr: any[]) => {
        if (/\[.*\]/.test(i)) {
          arr[index] = Number(row[i.replace(reg, "$1")]);
        }
      });
      let result = eval(oc.input.join(""));
      oc.trans && (result = callTransFn(oc.trans, result));
      return oc.prefix + result + oc.suffix;
    } catch (error) {
      this.$message.error("运算公式错误");
      console.error(error);
    }
  }
  // 获取关联流程数据源属性
  async getRelProcPrimeDataProps() {
    try {
      const { success, data, message } = await getRelProcPrimeDataProps(
        this.originData.pacId,
        this.originData.dataCfgId,
        this.widget.path
      );
      if (!success) {
        this.$message.error(message);
        return false;
      }
      if (Array.isArray(data)) {
        // 形成数据源字段与子表字段间的映射关系
        this.reflectMap = data.reduce((acc, cur) => {
          if (cur.primePropertyName) { // 有对应关系才添加，可能存在无对应关系的情况
            acc[cur.propertyNamePath] = cur.primePropertyName;
            acc[cur.primePropertyName] = cur.propertyNamePath;
          }
          return acc;
        }, {});
      } else {
        this.reflectMap = {};
      }
      return data;
    } catch (error) {
      console.error(error);
      this.$message.error("获取关联流程数据源属性失败");
      return false;
    }
  }

  addFromDataSource() {
    this.selectComponentLimiter = JSON.stringify({
      value: this.widget.dataSource,
      queryType: 0,
      label: "数据源"
    });
    this.showSelectComponent = true;
  }
  async handelSelectComponentConfirm(data: Record<string, any>) {
    if (
      !(
        Array.isArray(data.source) &&
        Array.isArray(this.widget.widgetList) &&
        data.source.length > 0
      )
    )
      return;
    if (this.widget.widgetList.length === 1) {
      /**
       * 处理只有一行数据的特殊情况，这种情况下如果子表每项都为空，直接替换行数据，而不是添加一行
       */
      const isRowEmpty = (this.widget.widgetList[0] as App.WebForm.Widget[]).every((item) => {
        return !item.value
      });

      if (isRowEmpty) {
        this.addSouceData(this.widget.widgetList[0], data.source[0]);
        return;
      }
    }
    // 添加一行数据
    this.addHandler();
    const lastItem = this.widget.widgetList[this.widget.widgetList.length - 1];
    this.addSouceData(lastItem, data.source[0]);
  }
  /**
   * 处理绑定的数据源与子表的映射关系
   */
  addSouceData(
    itemList: App.WebForm.Widget[],
    dataSource: Record<string, number | string | boolean>
  ) {
    if (Array.isArray(itemList)) {
      // 获取子表每项的path与该项的映射关系
      const widgthNamePathMap = itemList.reduce((pre, cur) => {
        pre[cur.path as string] = cur;
        return pre;
      }, {} as Record<string, App.WebForm.Widget>);
      // 遍历数据源，设置子表项的值
      Object.keys(dataSource).forEach((key) => {
        const widget = widgthNamePathMap[this.reflectMap[key]];
        if (widget) {
          widget.value = dataSource[key]; // 设置子表项的值
        }
      });
    }
  }
  mounted() {
    // 获取关联流程数据源
    if (this.widget.dataSource) {
      this.getRelProcPrimeDataProps();
    }
    this.$nextTick(() => {
      this.widget.widgetList.forEach((w: App.WebForm.Widget[]) => {
        w.forEach((e: App.WebForm.Widget) => {
          const ref = this.$refs[e.id] as any;
          // if (Object.prototype.toString.call(ref) === "[object Array]") {
          //   wgetMgr.setWidgetById(e.id, ref[0]);
          // } else {
          //   }
          wgetMgr.setWidgetById(e.id, ref);
        });
      });
    });
  }
}
